import { Add } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import React from "react";
import { useFormConfigContext } from "./ConfigFormContext";

const ConfigNoValidation: React.FC = () => {
  const { setValue } = useFormConfigContext();

  return (
    <>
      <Typography className="italic">
        Une validation permet d'évaluer certaines règles sur les résultats de
        votre traitement.
        <br />
        Cela peut vous permettre de vérifier l'exactitude ou la cohérence des
        données extraites.
      </Typography>
      <div className="flex justify-center">
        <Button
          variant="contained"
          onClick={() =>
            setValue("config.validation", {
              asset_rules: [],
              document_rules: [],
            })
          }
          className="gap-2"
        >
          <Add />
          Validation
        </Button>
      </div>
    </>
  );
};
export default ConfigNoValidation;
